import _ from 'lodash';
import { ZalohyState, zalohyStoreBuilder } from '@/modules/components/zalohy/store/edit';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { POLOZKY } from '@/modules/components/zalohy/constants';

import { apiProvider } from '../api';
import { CRUMB_LABEL_KEY as crumbLabel, NAME as name } from '../constants';

const zalohyStore = zalohyStoreBuilder(apiProvider);

const povStoreExtension = 	{
	name,
	apiProvider,
	crumbLabel,
	edit: {
		PovId: null as number | null,
		PovNr: null as number | null,
		PovzalohaId: null as number | null,
		PovzalohaNr: null as number | null,
		DphSzbOzn: null as number | null,
		ZakaznikText: null as string | null,
		Spz: null as string | null,
	},
	depTableSettings: {
		[POLOZKY]: {
			filter(state:ZalohyState) {
				return { PovzalohaId: state.props.id };
			},
		},
	},
	props: {
		filter: {
			PovId: null as number | null,
			PovNr: null as number | null,
		},
	},
};

export const store = editStoreBuilder(_.merge(zalohyStore, povStoreExtension));
